import { Dispatch, SetStateAction } from 'react';
import useTranslation from 'next-translate/useTranslation';

import NotificationsListItem from '@components/layout/Header/Notifications/NotificationsListItem/NotificationsListItem';
import { Notification } from '@components/layout/Header/Notifications/types';
import { dateSort } from '@utils/sorting';

import style from './NotificationsListGroup.module.scss';

interface Props {
  allList: Notification[];
  list: Notification[];
  setAllList: Dispatch<SetStateAction<Notification[]>>;
  title: string;
}

const NotificationsListGroup = ({ title = '', list = [], setAllList, allList }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const validList = list.filter(item => item.activity_id);
  const totalItems = validList.length;
  const sortedList = dateSort(validList, 'created_at', 'desc');

  return (
    <div className={style.group} data-testid='notifications-group'>
      <div className={style.header}>
        <h2 className={style.title} data-testid='notifications-group-title'>{title}</h2>
        <p
          className={style.count}
          data-testid='notifications-group-count'
          title={t('notifications.total_notifications', { count: totalItems })}
        >
          ({totalItems})
        </p>
      </div>
      {sortedList.length > 0 && sortedList.map((item: Notification) => (
        <NotificationsListItem
          key={`notification-${item.activity_id}`}
          allList={allList}
          item={item}
          setAllList={setAllList}
        />
      ))}
    </div>
  );
};

export default NotificationsListGroup;
